@if (media.status !== videoStatusStates.LIVE && player.playerData.showScrubberBar) {
  <div class="time-control">
    <mb-video-scrubber class="control-element" [player]="player" [media]="media"></mb-video-scrubber>
  </div>
}

<div class="control-items copy-s">
  <div class="state-btn control-element">
    <button
      class="btn btn-round"
      attr.aria-label="{{ ((player.playing$ | async) ? 'PAUSE' : 'PLAY') | translate }}"
      (click)="player.togglePlay()"
    >
      <span class="mb-icon mb-icon-player-{{ (player.playing$ | async) ? 'pause' : 'play' }}"></span>
    </button>
  </div>
  @if (media.status !== videoStatusStates.LIVE) {
    @if (!smallControls && player.playerData.showScrubberBar) {
      <mb-duration
        class="control-element"
        [currentTime]="player.currentTime"
        [duration]="player.duration"
      ></mb-duration>
    }
  } @else {
    <div class="live-indicator copy-s control-element">
      <mb-live-indicator></mb-live-indicator>
      {{ 'LIVE' | translate }}
    </div>
  }

  @if (tracks.length > 1) {
    <mb-dropdown
      class="control-element"
      [hideLabel]="smallControls"
      [options]="tracks"
      [openTop]="true"
      [icon]="'mb-icon-language-country-switch'"
      [value]="currentLang"
      (selectionChanged)="changeTrack($event)"
    ></mb-dropdown>
  }

  @if (player.hasVolume$ | async) {
    <div class="audio-control control-element">
      @if (!isIosDevice) {
        <div class="audio-scrubber-wrapper">
          @if (!smallControls) {
            <mb-scrubber
              [value]="(player.volume$ | async) || 0"
              (progressChanging)="player.setVolume($event)"
            ></mb-scrubber>
          }
        </div>
      }
      @if ((player.muted$ | async) === false) {
        @if (this.player.volume$ | async; as volume) {
          <span class="mb-icon mb-icon-sound-{{ volume > 50 ? 'high' : 'low' }}" (click)="player.mute()"></span>
        } @else {
          <span class="mb-icon mb-icon-sound-mute" (click)="player.unmute()"></span>
        }
      } @else {
        <span class="mb-icon mb-icon-sound-mute" (click)="player.unmute()"></span>
      }
    </div>
  }
  <div class="icon-btn-controls">
    @if (player.resolutions$ | async; as resolutions) {
      @if (!smallControls) {
        <mb-resolution-controller
          class="control-element"
          [openBottom]="smallControls"
          [resolutions]="resolutions"
          [isComposed]="player.playerData.isComposed"
          [activeResolution]="player.activeBitrate"
          (resolutionIndexChanged)="player.setBitrate($event)"
        ></mb-resolution-controller>
      }
    }
    @if (allowPictureInPicture && !smallControls) {
      <div class="control-element btn btn-quaternary" (click)="toggleFlyout()">
        <span class="mb-icon mb-icon-picture-in-picture"></span>
      </div>
    }
    @if (player.canFullscreen) {
      <div class="fullscreen-btn control-element btn btn-quaternary" (click)="player.toggleFullscreen()">
        <span class="mb-icon mb-icon-media-full-screen-{{ isFullscreen ? 'xs' : 'view-xs' }} "></span>
      </div>
    }
  </div>
  @if (!isEmbedPlayer && player.playerData.screenshotUrl && player.playerData.showScreenshotButton) {
    <div
      class="screenshot-btn btn btn-round"
      (click)="emitCapture()"
      (touchstart)="$event.stopPropagation()"
      (mousemove)="$event.stopPropagation()"
    >
      <span class="mb-icon mb-icon-image-gallery"></span>
    </div>
  }
</div>
